<template>
  <div class="animated fadeIn">

    <b-row>
      <b-col lg="12">
      <!--  <b-breadcrumb :items="breadcrumbs"/>   -->  
       <b-card header-tag="header" footer-tag="footer">
        <div slot="header">
          <strong>  Receivable Driver Dashboard </strong>  
        </div>
        <b-row class="mb-4">          
         <!--  <b-col md="6" class="my-1">
            <b-form-group label-cols-sm="3" label="Filter" class="mb-0">
              <b-input-group>
                <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col> -->
          <b-col md="6" class="my-1">
           <form >
            <b-row class="form-group">
              <b-col cols="2" >
                <b-col sm="12" >
                <label ><b>Date:</b></label>
              </b-col>
              </b-col>
              <b-col cols="4">
                 <v-date-picker mode='single' input-class="dateInput" :available-dates='{ start: null, end: new Date() }' v-model='selectedDate'>
                </v-date-picker> 
              </b-col>
               <b-col cols="6">
                <b-button size="md" variant="primary"  @click="displaydata">Search</b-button>&nbsp;&nbsp;&nbsp;
                
              </b-col>

            </b-row>               
            </form>               
          </b-col> 
            <div id="overlay" >
             <div class="loader"></div>
           </div>   
          <b-col sm="12" class="text-right">
                <b-button size="md" variant="primary" type="button" @click="downloadCSV">Download</b-button>
              </b-col> 
           <b-col sm="12" class="text-right">
               <p > <b>Total Records :<span style="color:red;">{{ this.totalRows }}</span></b> </p>
              </b-col>        
        </b-row>
<b-col sm="12" >
 <b-table  show-empty stacked="md"  :items="data" :fields="fields"  :bordered="bordered" thead-class="Collected"  :current-page="currentPage" :per-page="perPage"  :filter="filter"  @filtered="onFiltered"   :busy="isBusy">
  <template slot="total" slot-scope="row" >
 {{ formatPrice((parseFloat(row.item.pendingcodcollectable)+parseFloat(row.item.todays_codcollectable)))}}
    </template> 
    
    <template slot="pending" slot-scope="row" >
    {{ formatPrice((parseFloat(row.item.pendingcodcollectable)+parseFloat(row.item.todays_codcollectable)))}}
      
    </template> 
     <template slot="thead-top" slot-scope="data">
    <tr>
      <th></th>

      <th colspan="3"></th>
      <th colspan="3" class="align-middle">Collected from Rider</th>
    <th></th>
    </tr>
  </template>
   <template slot="show_details" slot-scope="row" >
            
              <b-button size="sm" @click="row.toggleDetails" class="mr-2" style="background: #b0c4de !important;color: #000 !important;">
                {{ row.detailsShowing ? 'Hide' : 'Show'}} Details
              </b-button>
            </template>
                  <template slot="row-details" slot-scope="row">
              <b-card>
                <b-row>
                  <b-col sm="6">

               <!--      <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b> Depositor Name:</b></b-col>
                      <b-col>{{ row.item.daname }}</b-col>
                    </b-row>

                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>ID:</b></b-col>
                      <b-col>{{ row.item.deliveryagentmasterid }}</b-col>
                    </b-row>
 -->
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Bank Transfer:</b></b-col>
                      <b-col>{{ row.item.bank_transfer }}</b-col>
                    </b-row>

                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b> Cash Deposite:</b></b-col>
                      <b-col>{{ row.item.cash_deposite }}</b-col>
                    </b-row>

                  <!--   <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b> Deposite Amount:</b></b-col>
                      <b-col>{{ row.item.deposite_amount }}</b-col>
                    </b-row> -->

                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b> Pending Collectable:</b></b-col>
                      <b-col>{{ row.item.pendingcodcollectable }}</b-col>
                    </b-row>

                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Today's Collectable:</b></b-col>
                      <b-col>{{ row.item.todays_codcollectable }}</b-col>
                    </b-row>
                    
                     <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Contracter Mobile No:</b></b-col>
                      <b-col>{{ row.item.deliveryagentmobilenumber  }}</b-col>
                    </b-row>
                              

                    
                     
                    
                    
                  </b-col>  
                  <b-col sm="6">
                   <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Is Verified:</b></b-col>
                      <b-col>{{ row.item.isverified }}</b-col>
                    </b-row>

                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Contractor Name:</b></b-col>
                      <b-col>{{ row.item.driver_contracter_name }}</b-col>
                    </b-row>

                     <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Contracter Email Id:</b></b-col>
                      <b-col>{{ row.item.contracter_emailid  }}</b-col>
                    </b-row>

                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Driving License:</b></b-col>
                      <b-col>{{ row.item.driving_license  }}</b-col>
                    </b-row>
                    
                          
                   </b-col> 
                  <b-col sm="12">
                  <div slot="footer" class="text-right">
                   <b-button size="sm" @click="row.toggleDetails" style="background: #b0c4de !important;color: #000 !important;">Hide Details</b-button>
                  </div> 
                 </b-col> 
                </b-row> 

              </b-card>
            </template>
  <div slot="table-busy" class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                      </div>     

</b-table>
  </b-col>               
                   <!--  <div  style="margin-top: 40px" v-if="this.totalRows > 0">
                    <table class="table table-responsive-sm table-bordered table-striped table-sm " border="1">
                       <tr class="table-active">
    <th rowspan="2">Rider Name</th>
    <th rowspan="2">Collectable for Rider Previous  day </th>
     <th rowspan="2">Collectable for Rider Today  </th>
     <th rowspan="2">Total Collectable  </th>
    <th colspan="2">Collected from Rider</th>
    <th rowspan="2">Pending with Rider  </th>
  </tr>

  <tr class="table-active">
    <th>Bank Transfer</th>
    <th>Cash to Account</th>

  </tr>

  <tr v-for="(value, firstIndex) in data">
                  
                  <td>{{ value.daname }}</td>
                  <td>{{ value.pendingcodcollectable }}</td>
                   <td>{{ value.todays_codcollectable }}</td>
                   <td>{{ formatPrice((parseFloat(value.pendingcodcollectable)+parseFloat(value.todays_codcollectable)))}}</td>
                   <td>{{ value.bank_transfer }}</td>
                      <td>{{ value.cash_deposite }}</td>

                      <td>{{formatPrice((parseFloat(value.pendingcodcollectable)+parseFloat(value.todays_codcollectable)))}}</td>
                     
                </tr>
                    </table>

                  </div> -->

         
            
           <b-col md="6" class="my-1" v-if="this.totalRows > 10">
          <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                class="my-0"
              ></b-pagination>
        </b-col> 

       </b-card>
        
      </b-col>
    </b-row><!--/.row-->

  </div>

</template>

<script>
import CONSTANTS from '@/utils/constants'
import Filters from '@/utils/filters'
import Utils from '@/utils'
export default {
  data: function() {
    return {
      name: 'codReports',
      data: [],
    
      pendingamount:[],
      items:[],
      isBusy: false,
      breadcrumbs: [{
        text: 'Dashboard',
        href: '/dashboard'
      },{
        text: 'COD Status Report',
        active: true
      }],
      fields:[
          { key: 'daname', label: 'Rider Name',sortable: true, sortDirection: 'desc'},
          { key: 'pendingcodcollectable', label: 'Collectable for Rider Previous day',sortable: true, sortDirection: 'desc'},
          { key: 'todays_codcollectable', label: 'Collectable for Rider Today',sortable: true, sortDirection: 'desc'},
          { key: 'total', label: 'Total Collectable',sortable: true, sortDirection: 'desc'},
          { key: 'bank_transfer', label: 'Bank Transfer',sortable: true, sortDirection: 'desc'},
          { key: 'cash_deposite', label: 'Cash to Account',sortable: true, sortDirection: 'desc'},
          { key: 'pending', label: 'Pending with Rider',sortable: true, sortDirection: 'desc'},
          { key: 'show_details', label: 'Action' }
         
          
      ],
      bordered: true,
      totalRows: 0,
      currentPage: 1,
      perPage:  10,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      selectedDate: new Date(),
    }
  },
  computed: {
    sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
      }
  },
  created: function () {
    this.displaydata()
  },

  methods: {
    
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
    
    displaydata: function () {
       this.isBusy = true;
      //var fromdate = this.formatDate(this.selectedDate);
       
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      //console.log(userInfo);
      const customerGetobj = {
          email: `${userInfo.sysemailid}`,
          fromdate: this.formatDate(this.selectedDate),
           hub_id:`${userInfo.pickuplocationmasterid}`,
          //deliveryagentmasterid:"529",
          is_finance_superadmin:`${userInfo.is_finance_superadmin}`,
      }
      this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/financedashboardriderwisereport`, customerGetobj)
        .then((result) => {
          if (result.body.returnmsg === 'Successful') {
            this.isBusy = !this.isBusy
            this.data = result.body.returnvalue
            
            //this.items  = result.body.returnvalue;
            this.totalRows = result.body.returnvalue.length
            // console.log(this.totalRows) ; 


          } else {
            this.isBusy = !this.isBusy
            this.items  = result.body.returnvalue;
            this.totalRows = result.body.returnvalue.length
          }
        })
        .catch((ex) => {
          console.log('error-----', ex)
        })
    },
    

    formatPrice(value) {
     
         let val = (value/1).toFixed(2).replace('.', '.')
         return val.toString().replace(/\B(?=(\d{6})+(?!\d))/g, ".")
     },
    //    formatPrice1(value1,value2,value3,value4) {
    //     if(value3=='null')
    //     {
    //       var value3_1;
    //       this.value3_1=0;
        
          
    //     }
    //     else
    //     {
    //           this.value3_1=value3;
    //     }
    //      if(value4=='null')
    //     {
    //       var value4_1;
    //       this.value4_1=0;
          
    //     }
    //     else
    //     {
    //        this.value4_1=value4;
    //     }


     
    //     return((value1+value2)-(value3_1+value4_1))
    // },
         downloadCSV: function() {
           var userdata = localStorage.getItem('userData')
            var userInfo = JSON.parse(userdata)
      //alert("dowanloading")
   document.getElementById("overlay").style.display = "block";
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      var fromdate = (this.selectedDate!=null)?this.formatDate(this.selectedDate):"";
     
 
var csvObj = {
email: `${userInfo.sysemailid}`,
fromdate: `${fromdate}`,
sysusermasterid:`${userInfo.sysusermasterid}`,
 hub_id:`${userInfo.pickuplocationmasterid}`,
 is_finance_superadmin:`${userInfo.is_finance_superadmin}`,
}

   
      
        // var queryString ="?"+ Object.keys(csvObj).map(key => key + '=' + csvObj[key]).join('&');
  
      //var r = Math.random().toString(36).substring(3);
  this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/financedashboardriderwisereportcsv_advanced`,csvObj)
        .then(result => {
         console.log(result.url);
         document.getElementById("overlay").style.display = "none";
          if(result.body=="success")
         {
         alert("Please Check Ur Mail For Downlod Link")
          // this.$fire({
          //         text:"Please Check Ur Mail For Downlod Link",
          //         type: "success",
          //         timer: 30000
          //       }); 
       }
       else
       {
        alert("Can not Download");
        // this.$fire({
        //           text:"Can not Download",
        //           type: "error",
        //           timer: 30000
        //         }); 
       }
        //window.location.href =result.url;
        });
        
    },

//       downloadCSV: function() {
//       //alert("dowanloading")
  
//       var userdata = localStorage.getItem('userData')
//       var userInfo = JSON.parse(userdata)
//       var fromdate = (this.selectedDate!=null)?this.formatDate(this.selectedDate):"";
     
 
// var csvObj = {
// email: `${userInfo.sysemailid}`,
// fromdate: `${fromdate}`
// }

   
      
//         var queryString ="?"+ Object.keys(csvObj).map(key => key + '=' + csvObj[key]).join('&');
  
//       //var r = Math.random().toString(36).substring(3);
//   this.$http.get(`${CONSTANTS.MISREPORT_API_URL}/financedashboardriderwisereportcsv`+queryString)
//         .then(result => {
//          // console.log(result.url);
//         window.location.href =result.url;
//         });
        
//     },

    formatDate: function(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("-");
    },
  }
}
</script>

<style type="text/css">
 .totalback
 {
  background: #c8ced3 !important;
   border-right: 1px solid grey !important;

  }
   
   .Collected
   {
    text-align: center !important;
   }
  #overlay {
  position: fixed; /* Sit on top of the page content */
  display: none; /* Hidden by default */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5); /* Black background with opacity */
  z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
  .loader {
  position: relative;
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  width: 30px;
  height: 30px;
  left:50%;
  top:50%;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}


/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

</style>